import { Component } from "@theme/component";
import { debounce, fetchConfig } from "@theme/utilities";
import { storefrontEvents } from "@theme/storefront-events";

/**
 * A custom element that displays a cart note.
 */
class CartNote extends Component {
  /** @type {AbortController | null} */
  #activeFetch = null;

  /**
   * Handles updates to the cart note.
   * @param {InputEvent} event - The input event in our text-area.
   */
  updateCartNote = debounce(async (event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;

    const note = event.target.value;
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const abortController = new AbortController();
    this.#activeFetch = abortController;

    const noteUpdate = storefrontEvents.start(this, "CartNoteUpdateEvent", {
      context: this.closest("cart-drawer-component") ? "dialog" : "cart",
      note,
    });

    try {
      const config = fetchConfig("json", {
        body: JSON.stringify({ note }),
      });

      const response = await fetch(FoxTheme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });
      const cart = await response.json();

      const errorMessage = storefrontEvents.getAjaxError(cart);
      storefrontEvents.resolveCart(noteUpdate, errorMessage ? null : cart, errorMessage);
    } catch (error) {
      // A newer keystroke aborted this request: its event is rejected without a cart error.
      storefrontEvents.failCart(this, noteUpdate, error);
    } finally {
      // Only this request\'s controller: a newer request that aborted this one keeps its own.
      if (this.#activeFetch === abortController) this.#activeFetch = null;
      // cartPerformance.measureFromEvent("note-update:user-action", event);
    }
  }, 200);
}

if (!customElements.get("cart-note")) {
  customElements.define("cart-note", CartNote);
}
